import { result } from 'lodash';
import styled from 'styled-components';
import { BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Body5Regular, Caption1Medium } from 'styles/Global/typography';
import { formatThousandsComma } from 'utils/calculateMoney';
import { formatDateFlexible } from 'utils/calculateTime';

export default function PaymentInfo(paymentInfo?: any) {
    const resultInfo = paymentInfo?.paymentInfo?.paymentResult;

    return resultInfo ? (
        <PaymentInfoContainer>
            <InfoFieldContainer>
                <FieldTitleContainer>
                    <Caption1Medium $color={TextColor.color_text_light}>결제 일시</Caption1Medium>
                </FieldTitleContainer>
                <Body5Regular>{formatDateFlexible(resultInfo.trdDtm, 'YYYY/MM/DD HH:mm', 'YYYYMMDDHHmmss')}</Body5Regular>
            </InfoFieldContainer>
            <InfoFieldContainer>
                <FieldTitleContainer>
                    <Caption1Medium $color={TextColor.color_text_light}>결제 수단</Caption1Medium>
                </FieldTitleContainer>
                <Body5Regular>{resultInfo.cardNm}</Body5Regular>
            </InfoFieldContainer>
            <InfoFieldContainer>
                <FieldTitleContainer>
                    <Caption1Medium $color={TextColor.color_text_light}>주문 금액</Caption1Medium>
                </FieldTitleContainer>
                <Body5Regular>{formatThousandsComma(resultInfo.trdAmt)}원</Body5Regular>
            </InfoFieldContainer>
        </PaymentInfoContainer>
    ) : null;
}

const InfoFieldContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
`;

const FieldTitleContainer = styled.div`
    width: 60px;
`;

const PaymentInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid ${BorderColor.color_border_weak};
    padding: 16px;
    gap: 6px;
`;
